import React from 'react';
import { useI18n } from '../../i18n/I18nContext';
import './ComingSoon.css';

/**
 * `title`/`description` are rendered verbatim (already-resolved text).
 * `titleKey`/`descriptionKey` are i18n keys (from any namespace, e.g.
 * 'ui.offlineEventsTitle') that get passed through t() -- prefer these
 * from route definitions so the page localizes under ru/uz instead of
 * needing the caller to resolve translations itself. When both a key
 * and a literal are given, the key wins.
 */
function ComingSoon({ title, description, titleKey, descriptionKey }) {
  const { t } = useI18n();
  const resolvedTitle = titleKey ? t(titleKey) : title;
  const resolvedDescription = descriptionKey
    ? t(descriptionKey)
    : (description || t('ui.comingSoonDefaultDesc'));

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-card">
        <div className="coming-soon-icon">
          <svg width="28" height="28" viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" strokeDasharray="6 4" />
            <path d="M24 14v12l7 4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1 className="coming-soon-title">{resolvedTitle}</h1>
        <p className="coming-soon-description">{resolvedDescription}</p>
        <div className="coming-soon-badge">{t('ui.comingSoonBadge')}</div>
      </div>
    </div>
  );
}

export default ComingSoon;
